
import {catchError, tap, map} from 'rxjs/operators';
/**
 * Authentication service
 * xsecurity generator
 **/

// Core
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import _isString from 'lodash-es/isString';
import _forEach from 'lodash-es/forEach';
import _startsWith from 'lodash-es/startsWith';
import _trimStart from 'lodash-es/trimStart';
import _set from 'lodash-es/set';
import _setWith from 'lodash-es/setWith';
import _assign from 'lodash-es/assign';
import _get from 'lodash-es/get';
import { HttpClient } from '@angular/common/http';

// Import RxJs required methods



@Injectable()
export class RightsService {

    //XXX Dummy for now, need to get real user rights once complete
    private permissionResponse: Observable<any>;
    private permission: any = {};
    private overWrite: any = {};

    private rightsUrl = sessionStorage.getItem('$wui_url')+"config/rights/rights.json";


    public display = {"root":""};

    constructor(
        private readonly http: HttpClient
    ) {}

    /**
     * setPermission
     * set a right
     * can be used to overright a right from interface
     * @item : json path
     * @state : true or false
    */
    public setPermission(item: string, state: boolean): void {
        _setWith(this.permission, item, state, Object);
    }

    public setPermissions(name: string, permissions: any): void{
        _assign(this.permission[name], permissions);
    }

    /**
     * getPermission
     * get a right from an external file
     * @item : json path
    */
    public getPermission(item: string): boolean {
        return _get(this.permission, item, false);
    }

    public getRights(): Observable<any>{
        if (!this.permissionResponse){
           this.permissionResponse = this.http.get(this.rightsUrl).pipe(
            tap(permission => {
                _assign(this.permission, permission, this.permission);
            }),
            catchError( (error:any):any => {}),);
        }

        return this.permissionResponse;
    }


    /**
     *
     * @param {string | Array<string>} _perm : permission or array of permission. A permission can begin with !
     * @param {string | Array<string>} _otherRoot : change between app root and "general" for exemple
     * @returns {boolean}
     */
    public isPerm(_perm: string|Array<string>, _otherRoot?: string): boolean{

        let permArray: any;
        //Test : if is string|array
        if( _isString( _perm ) ){
            permArray = [_perm];
        }else{
            permArray = _perm;
        }

        let view = true;

        _forEach( permArray, (permStr: string)=>{
            if( !this.checkRight(permStr, _otherRoot) ){
                view = false;
            }
        } );

        return view;
    }


    /**
     * checkRight
     *
     * @param {string} perm : permission string
     * @returns {boolean}
     */
    public checkRight(perm: string, _otherRoot?: string): boolean{
        let output: boolean;
        // should the perm is true or false ? find '!' in start of string
        let boolToFind: boolean= true;
        if( _startsWith(perm, '!') ){
            boolToFind= false;
        }
        perm = _trimStart(perm, '!');
        let permissionData: boolean;
        if(!_otherRoot){
            permissionData = this.getPermission(this.display.root + '.' + perm);
        }else{
            permissionData = this.getPermission(_otherRoot + '.' + perm);
        }

        output = permissionData === boolToFind;
        return output;

    }

    /**
     * set overRight var, used in iqba external json
     * @param {string} _perm : json path
     * @param _value : value to assign
     */
    public setOverWrite(_perm: string, _value: any): void{
        _set( this.overWrite, _perm, _value);
    }
}
